<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    top="7vh"
    class="element-img-upload-dialog"
    :before-close="beforeClose"
    :visible.sync="visible"
  >
    <h2 class="modal-header-title" slot="title">上传图片</h2>
    <div class="picture-list">
      <div class="uploader-header">
        <div class="group-select">
          <label class="text">上传到分组：</label>
          <el-select v-model="imgCatalog" placeholder="请选择上传到的图片分组">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.cataName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div
        class="uploader-content"
        :class="{ 'add-center': fileList.length === 0 }"
      >
        <div class="img-item" v-for="item in fileList" :key="item.uid">
          <div class="img-size">
            <img :src="item.url" :id="item.uid" @click="onPreview(item)" />
            <div class="percentage">
              <div class="sum-percentage"></div>
              <div v-if="item.status === 'ready'">
                <p class="current-percentage-text">
                  {{ fileStatus.ready.text }}
                </p>
              </div>
              <div v-if="item.status === 'uploading'">
                <p class="current-percentage-text">
                  {{
                    item.percentage === 100 && item.status === "uploading"
                      ? 99.9
                      : Number(item.percentage).toFixed(1)
                  }}%
                </p>
                <div
                  class="current-percentage"
                  :style="[
                    { background: fileStatus.uploading.background },
                    { width: item.percentage + '%' }
                  ]"
                ></div>
              </div>
              <div v-if="item.status === 'success'">
                <p class="current-percentage-text">
                  {{ fileStatus.success.text }}
                </p>
                <div
                  class="current-percentage"
                  :style="[
                    { background: fileStatus.success.background },
                    { width: item.percentage + '%' }
                  ]"
                ></div>
              </div>
              <div v-if="item.status === 'fail'">
                <p class="current-percentage-text">
                  {{ fileStatus.fail.text }}
                </p>
                <div
                  class="current-percentage"
                  :style="[
                    { background: fileStatus.fail.background },
                    { width: item.percentage + '%' }
                  ]"
                ></div>
              </div>
              <div v-if="item.status === 'saveErr'">
                <p class="current-percentage-text">
                  {{ fileStatus.saveErr.text }}
                </p>
                <div
                  class="current-percentage"
                  :style="[
                    { background: fileStatus.saveErr.background },
                    { width: item.percentage + '%' }
                  ]"
                ></div>
              </div>
            </div>
          </div>
          <i
            class="jc-icon icon-cancel img-item-cancel"
            v-if="item.status !== 'success'"
            @click.stop="delFile(item)"
          ></i>
          <div class="img-name">{{ item.name ? item.name : "" }}</div>
        </div>
        <el-upload
          v-show="!cancelUpload"
          ref="upload"
          action="/eshop/pub/file/upload/add"
          :accept="uploaderOptions.accept"
          :drag="uploaderOptions.drag"
          :multiple="uploaderOptions.multiple"
          :show-file-list="false"
          :data="uploaderOptions.data"
          :limit="uploaderOptions.limit"
          :auto-upload="uploaderOptions.autoUpload ? true : false"
          :disabled="uploaderOptions.disabled"
          :file-list="fileList"
          :on-remove="onRemove"
          :on-success="onSuccess"
          :on-error="onError"
          :on-progress="onProgress"
          :on-change="onChange"
          :before-remove="beforeRemove"
          :before-upload="beforeUpload"
          :on-exceed="onExceed"
          list-type="picture"
        >
          <div
            class="upload-icon-height"
            :class="{ 'add-center': fileList.length === 0 }"
          >
            <div class="add-content">
              <i class="el-icon-plus"></i><span> &nbsp;{{ addText }}</span>
            </div>
            <div slot="tip" class="text-desc">
              <slot name="formatDesc"></slot>
            </div>
          </div>
        </el-upload>
        <el-dialog :visible.sync="uploaderOptions.dialogVisible">
          <img width="100%" :src="uploaderOptions.dialogImageUrl" alt="图片" />
        </el-dialog>
      </div>
      <div class="uploader-footer" v-if="fileList.length > 0">
        <div class="uploader-btn" v-if="!allFileUploadSuccess">
          <el-button
            @click.stop="startUploader"
            type="primary"
            v-if="!uploaderOptions.autoUpload && startUpload"
            >开始上传</el-button
          >
          <el-button
            @click.stop="cancelUploader"
            v-if="!uploaderOptions.autoUpload && cancelUpload"
            type="danger"
            >取消上传</el-button
          >
          <p class="text" v-if="fileList.length > 0">
            共 {{ fileList.length }} 张图片，{{
              imgSize
            }}M（上传过程中请不要删除原始图片）
          </p>
        </div>
        <div class="uploader-btn" v-else>
          <el-button @click="beforeClose" type="primary">完成上传</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    uploaderOptions: {
      // 上传操作项
      type: Object,
      default: null
    },
    value: Boolean, // 是否显示
    select: [String, Number]
  },
  watch: {
    visible(val) {
      if (val) {
        // 等于true 说明打开窗体，则去拉取分类信息
        this.getImageList(); // 获得音频分类列表
      }
      this.$emit("input", val);
    },
    value(val) {
      this.visible = val;
    },
    fileList(val) {
      if (val.length > 0) {
        this.addText = "继续添加图片";
      } else {
        this.addText = "添加图片";
      }
    }
  },
  data() {
    return {
      fileList: [],
      addText: "添加图片", // 添加图片按钮的文本
      imgSize: 0, // 上传图片总大小
      uploadText: "开始上传", // 上传按钮文本
      startUpload: true, // 开始上传状态
      cancelUpload: false, // 取消上传状态
      visible: false, // 展示模态框
      successFileList: [], // 上传成功文件
      allFileUploadSuccess: false, // 所有文件上传成功
      fileStatus: {
        fail: {
          text: "上传失败",
          background: "rgba(245, 108, 108, 0.8)"
        },
        success: {
          text: "上传成功",
          background: "rgba(103, 194, 58,0.8)"
        },
        ready: {
          text: "等待上传"
        },
        uploading: {
          text: "正在上传",
          background: "#409EFF"
        },
        saveErr: {
          text: "上传失败",
          background: "rgba(245, 108, 108, 0.8)"
        }
      },
      imgCatalog: null, // 当前选中的分组
      options: [] // 分组列表
    };
  },
  methods: {
    delFile(item) {
      let index = this.fileList.findIndex(file => file.uid === item.uid);
      if (index !== -1) this.fileList.splice(index, 1);
      this.imgSize = 0;
      this.fileList.forEach(item => {
        if (item.size) {
          this.imgSize = this.imgSize + item.size;
        }
      });
      if (this.imgSize) {
        this.imgSize = (this.imgSize / 1024 / 1024).toFixed(3);
      }
      this.$refs.upload.abort(item);
      if (
        this.fileList.filter(item => item.status === "success").length ===
        this.fileList.length
      ) {
        this.startUpload = true;
        this.cancelUpload = false;
      }
    },
    onSuccess(response, file, fileList) {
      // 文件上传成功的钩子
      let index = this.fileList.findIndex(f => f.uid === file.uid);
      var img = document.getElementById(file.uid);
      file.imagePixel = img.naturalWidth + "*" + img.naturalHeight;
      if (index !== -1) {
        this.fileList[index].percentage = file.percentage;
        this.fileList[index].imagePixel =
          img.naturalWidth + "*" + img.naturalHeight;
      }
      setTimeout(() => {
        this.$api("element/addImg", {
          imageCataId: this.imgCatalog,
          platformType: file.response.data.platformType,
          imageFileId: file.response.data.id,
          imageName: file.name,
          imageFileUrl: file.response.data.fileUrl,
          imagePixel: file.imagePixel,
          imageSize: file.size
        })()
          .then(data => {
            this.fileList[index].status = file.status;
            let l = this.fileList.filter(
              f =>
                f.percentage === 100 &&
                (f.status === "success" || f.status === "fail")
            );
            if (l.length === this.fileList.length) {
              this.cancelUpload = false;
              this.startUpload = true;
              this.$refs.upload.clearFiles();
              this.allFileUploadSuccess = true;
              this.$emit("all-upload-success", this.fileList); // 文件上传完成的通知
            }
          })
          .catch(() => {
            let l = this.fileList.filter(
              f =>
                f.percentage === 100 &&
                (f.status === "success" || f.status === "fail")
            );
            if (l.length === this.fileList.length) {
              this.cancelUpload = false;
              this.startUpload = true;
              this.$refs.upload.clearFiles();
              this.allFileUploadSuccess = true;
              this.$emit("all-upload-success", this.fileList); // 文件上传完成的通知
            }
            let index = this.fileList.findIndex(item => item.uid === file.uid);
            if (index !== -1) {
              this.fileList[index].status = "fail";
            }
            // if (err) {
            //   this.$set.error(err && err.data ? err.data.msg : err.msg)
            // }
          });
      }, 20);
      this.$emit("on-success", response, file, this.fileList);
    },
    onError(err, file, fileList) {
      // 文件上传失败时的钩子
      let index = this.fileList.findIndex(f => f.uid === file.uid);
      if (index !== -1) {
        this.fileList[index].status = file.status;
      }
      this.$emit("on-error", err, file, fileList);
    },
    onProgress(e, file, fileList) {
      // 文件上传时的钩子
      let index = this.fileList.findIndex(f => f.uid === file.uid);
      if (index !== -1) {
        this.fileList[index].percentage = file.percentage;
        this.fileList[index].status = "uploading";
      }
      // this.$emit('on-progress', event, file, fileList)
    },
    onChange(file, fileList) {
      // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
      if (file.status === "ready") {
        this.fileList.push({
          ...file
        });
      }
      if (this.fileList.findIndex(item => item.status === "ready") !== -1) {
        this.allFileUploadSuccess = false;
      }
      this.imgSize = 0;
      fileList.forEach(item => {
        if (item.size) {
          this.imgSize = this.imgSize + item.size;
        }
      });
      if (this.imgSize) {
        this.imgSize = (this.imgSize / 1024 / 1024).toFixed(3);
      }
      this.$emit("on-change", file, fileList);
    },
    onRemove(file, fileList) {
      // 文件列表移除时的钩子
      this.$emit("on-remove", file, fileList);
    },
    onPreview(file) {
      // 点击文件列表中已上传的文件时的钩子(方法作废)
      this.$emit("on-preview", file);
    },
    beforeUpload(file) {
      // 上传之前的钩子
      this.$emit("before-upload", file);
    },
    beforeRemove(file, fileList) {
      // 移除之前的钩子
      this.$emit("before-remove", file, fileList);
    },
    onExceed(files, fileList) {
      // 文件超出个数限制时的钩子
      this.$emit("on-exceed", files, fileList);
    },
    startUploader() {
      // 开始上传
      let upload = this.fileList.filter(item => item.status !== "success");
      if (upload.length > 0) {
        this.startUpload = false;
        this.cancelUpload = true;
        this.$refs.upload.submit();
      } else {
        this.$message.warning("请先添加需要上传的图片");
      }
    },
    cancelUploader() {
      // 取消上传
      let cancelUpload = [];
      this.fileList.forEach((item, index) => {
        if (item.status === "uploading") {
          this.$refs.upload.abort(item);
        }
        if (item.status === "success") {
          cancelUpload.push(item);
        }
      });
      this.fileList = cancelUpload;
      let index = this.fileList.findIndex(item => item.status !== "success");
      if (this.fileList.length > 0 && index === -1) {
        this.allFileUploadSuccess = true;
      }
      this.$refs.upload.clearFiles();
      this.cancelUpload = false;
      this.startUpload = true;
    },
    beforeClose() {
      // 模态框关闭之前的事件
      if (this.fileList.length > 0 && !this.allFileUploadSuccess) {
        this.$confirm("存在未上传图片，是否退出?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.visible = false;
            this.allFileUploadSuccess = false;
            if (this.options.length > 0) {
              this.imgCatalog = this.options[0].id;
            }
            this.fileList = []; // 清空列表
            this.$emit("before-close", this.fileList); // 关闭之前发送上传成功的图片数组
          })
          .catch(() => {});
      } else {
        this.visible = false;
        this.allFileUploadSuccess = false;
        if (this.options.length > 0) {
          this.imgCatalog = this.options[0].id;
        }
        this.fileList = []; // 清空列表
        this.$emit("before-close", this.fileList); // 关闭之前发送上传成功的图片数组
      }
    },
    // onClickSuccessUpload () { // 点击完成上传保存图片到相册
    //   this.visible = false
    // },
    // onClickClose () { // 关闭上传窗口
    //   let saveErr = this.fileList.filter(item => item.status === 'saveErr').length > 0
    //   if (this.isSave) {
    //     this.beforeClose()
    //     this.$emit('all-upload-success', this.fileList) // 文件上传完成的通知
    //   } else if (saveErr) {
    //     this.beforeClose()
    //   } else if (!this.isSave) {
    //     this.$confirm('上传的图片没有保存是否退出?', '提示', {
    //       confirmText: '确定',
    //       cancelText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       this.beforeClose()
    //       this.$emit('all-upload-success', this.fileList) // 文件上传完成的通知
    //     }).catch(() => {})
    //   }
    // },
    getImageList() {
      // 获得元素分类列表
      this.$api("element/allCatalogList", {
        // 获得左侧节点列表
        typeId: 1 // 类型ID
      })()
        .then(data => {
          if (data.list && data.list.length > 0) {
            this.options = data.list[0].childrenList;
            if (this.select) {
              this.imgCatalog = this.select;
            } else {
              this.imgCatalog = this.options[0].id;
            }
          }
        })
        .catch(err => {
          this.$message.error(
            err.data && err.data.msg ? err.data.msg : err.msg
          );
        });
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
@import "@/assets/scss/variable.scss";
.element-img-upload-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #e7ecf1;
  }
  .el-select-dropdown {
    z-index: 9999 !important;
  }
  .picture-list {
    background: $white_color;
    .uploader-header {
      //  头部
      height: 70px;
      border-bottom: none;
      line-height: 68px;
      .group-select {
        width: 96%;
        margin: auto;
        border-bottom: 1px solid $theme;
        .text {
          display: inline-block;
          padding-right: 20px;
          text-align: right;
        }
      }
    }
    .add-center {
      text-align: center;
    }
    .uploader-content {
      // 内容
      border-top: none;
      border-bottom: none;
      height: 500px;
      overflow: auto;
      padding: 10px 20px;
      .upload-icon-height {
        min-height: 177px;
        width: 170px;
        margin: 20px 9px 0px 10px;
        box-sizing: border-box;
        float: left;
        .add-content {
          height: 150px;
          width: 170px;
          line-height: 150px;
          border: 1px dashed rgb(228, 228, 228);
          margin-bottom: 8px;
        }
        .text-desc {
          // 上传规则的描述文本
          color: $dark_gray;
        }
      }
      .img-item {
        min-height: 180px;
        width: 170px;
        margin: 20px 9px 0px 10px;
        box-sizing: border-box;
        float: left;
        overflow: hidden;
        .percentage {
          height: 20px;
          position: relative;
          bottom: 25px;
          text-align: center;
          .sum-percentage {
            // 总百分比
            height: 100%;
            width: 100%;
            background: black;
            opacity: 0.5;
            position: absolute;
          }
          .current-percentage {
            height: 100%;
            position: absolute;
            transition: width 0.3s;
            width: 0;
          }
          .current-percentage-text {
            color: white;
            line-height: 20px;
            height: 20px;
            top: 0px;
            position: absolute;
            z-index: 2;
            width: 100%;
          }
        }
        .img-size {
          height: 150px;
          width: 170px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        &-cancel {
          display: inline-block;
          position: relative;
          float: right;
          top: -145px;
          right: 5px;
          width: 23px;
          text-align: center;
          height: 23px;
          line-height: 23px;
          border-radius: 20px;
          font-size: 12px;
          background: $theme;
          color: $white_color;
          cursor: pointer;
          &:hover {
            font-weight: bold;
          }
        }
        .img-name {
          text-align: center;
          color: $dark_gray;
          font-size: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 5px 0px 0px 8px;
        }
      }
    }
    & > .uploader-footer {
      // 底部样式
      height: 100px;
      .uploader-btn {
        padding-top: 20px;
        text-align: center;
        width: 96%;
        margin: auto;
        border: none;
        border-top: 1px solid $theme;
        min-height: 96px;
        border-radius: 0px;
        &:hover {
          background-color: #fff;
        }
        .text {
          font-size: 12px;
          color: $dark_gray;
          line-height: 35px;
        }
      }
    }
  }
  .jc-modal {
    width: 54% !important;
    & .jc-modal-body {
      min-height: 630px;
      padding: 30px 20px;
    }
    .el-upload-dragger {
      // 文件拖拽的区域大小
      width: 182px;
      height: 172px;
      border: none;
    }
    .jc-modal-footer {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/picture-upload/picture-uploader.vue